var render, staticRenderFns
import script from "./FeatherIcon.vue?vue&type=script&lang=js"
export * from "./FeatherIcon.vue?vue&type=script&lang=js"
import style0 from "./FeatherIcon.vue?vue&type=style&index=0&id=79aa3e23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports